import React, { Fragment } from "react";

import { string, func } from "prop-types";

import { SelectListGroup, TextFieldGroup } from "../../../common";

import { titleOptions } from "../../../helpers";

import * as style from "./styles.module.scss";

const Names = ({
  memberTitle,
  memberFirstName,
  memberLastName,
  handleChange,
}) => (
  <Fragment>
    <div className={`row mt-1`}>
      <div className={`col-md-3 ${style.title}`}>
        <div className="form-group">
          <label htmlFor="title">Title</label>
          <SelectListGroup
            value={memberTitle}
            onChange={(e) => handleChange("title", e.target.value)}
            options={titleOptions}
            classes={`register_field register_field-dropdown`}
            isBold
          />
        </div>
      </div>
    </div>
    <div className={`row mb-0`}>
      <div className={`col-9 col-sm-4 col-lg-6`}>
        <div className="form-group">
          <label htmlFor="firstName">First name</label>
          <TextFieldGroup
            inputId="firstName"
            inputName="firstName"
            value={memberFirstName}
            onChange={(e) => handleChange("firstName", e.target.value)}
            classes={`register_field`}
            isBold
          />
        </div>
      </div>
      <div className={`col-9 col-sm-4 col-lg-6`}>
        <div className="form-group">
          <label htmlFor="lastName">Last name</label>
          <TextFieldGroup
            inputId="lastName"
            inputName="lastName"
            value={memberLastName}
            onChange={(e) => handleChange("lastName", e.target.value)}
            classes={`register_field`}
            isBold
          />
        </div>
      </div>
    </div>
  </Fragment>
);

Names.propTypes = {
  memberTitle: string.isRequired,
  memberFirstName: string.isRequired,
  memberLastName: string.isRequired,
  handleChange: func.isRequired,
};

export default Names;
